@let userInteracts = this.userInteracts();


<div
  class="content"
  [class.fullscreen]="widgetUi.tabBarAutoHide && !userInteracts"
  [@routeAnimations]="outlet?.activatedRouteData?.['animation']"
>
  <div
    class="clickable-media"
    [dwallClickableMedia]="['/main', 'home', 'special-offer']"
  ></div>

  <core-background-player
    class="background-player"
  />

  <router-outlet #outlet="outlet"/>
</div>

<app-tab-bar/>
